import { useSyncExternalStore } from 'react';
import { useMe, useOrders } from './queries';
import {
  PRINT_QUEUE_PAGE_SIZE,
  PRINT_QUEUE_SOURCES,
  PRINT_QUEUE_STATUSES,
  getPrintedVersion,
  isPrintQueueOrder,
  loadPrintedIds,
  markPrinted,
  subscribePrinted,
} from '../lib/print-queue';

/**
 * Yazdırma kuyruğu verisi. Yeni API ucu YOK: mevcut `useOrders` sorgusu (`/api/orders`) kanal ve
 * durum CSV süzgeciyle çağrılır. Menü rozeti ile ekran aynı önbellek anahtarını paylaşır; rozet
 * sorgunun yenilenme aralığıyla (15 sn) güncellenir.
 *
 * Basıldı durumu `lib/print-queue.ts`'teki ortak abonelikle okunur: bir yerde basılınca aynı
 * ağaçtaki tüm kuyruk görünümleri (rozet dahil) hemen güncellenir.
 *
 * `enabled`: rozet yalnız OWNER/MANAGER için sorgulanır (`/api/orders` zaten bu rollere açık).
 */
export function usePrintQueue(enabled: boolean) {
  const me = useMe();
  const tenantId = me.data?.tenantId ?? null;
  const orders = useOrders(
    {
      status: PRINT_QUEUE_STATUSES.join(','),
      source: PRINT_QUEUE_SOURCES.join(','),
      pageSize: String(PRINT_QUEUE_PAGE_SIZE),
    },
    enabled,
  );
  // Dönen değer kullanılmaz; yalnız değişimde yeniden çizimi tetikler.
  useSyncExternalStore(subscribePrinted, getPrintedVersion);

  const page = orders.data;
  const queue = (page?.items ?? []).filter(isPrintQueueOrder);
  const printed = loadPrintedIds(tenantId);
  const unprintedCount = queue.filter((o) => !printed.has(o.id)).length;
  // Sunucuda daha fazla kayıt var ama sayfa boyutu yetmedi: gizli kalan siparişler olabilir.
  const total = page?.total ?? 0;
  const truncated = total > (page?.items.length ?? 0);

  return {
    queue,
    printed,
    unprintedCount,
    total,
    truncated,
    isPending: orders.isPending,
    isError: orders.isError,
    markOrdersPrinted: (orderIds: string[]) => markPrinted(tenantId, orderIds),
  };
}
